import styles from "./styles.module.css";
import { useMemo } from "react";
import { HiOutlineArrowNarrowDown } from "react-icons/hi";
import { GrDrag } from "react-icons/gr";
import { useDrop, useDrag } from "react-dnd";
import usePropFormatter from "../../../utils/usepropformatter";

export default function ActionCard({
  action,
  path,
  onDelete,
  onClick,
  index,
  onDragDrop,
  onDrop,
}) {
  const handleDrop = (item, monitor) => {
    if (!monitor.isOver({ shallow: true })) {
      return;
    }
    onDrop(item.action, item.path, path);
  };

  const [{ dragging }, dragRef] = useDrag({
    item: {
      type: "action",
      index: index,
      action: { ...action },
      path: path,
    },
    collect: (monitor, props) => ({
      dragging: monitor.isDragging(),
    }),
  });

  const [{ hovered }, dropRef] = useDrop({
    accept: "action",
    drop: handleDrop,
    //canDrop: (item, montior) => item.index !== index,
    collect: (monitor) => ({
      hovered: !!monitor.isOver({ shallow: true }) && monitor.canDrop(),
    }),
  });

  return (
    <div
      style={{
        display: dragging ? "none" : "flex",
      }}
      className={styles.actionContainer}
      ref={dropRef}
    >
      <div
        ref={dragRef}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={onClick}
        className={styles.actionCard}
      >
        <div style={{ display: "flex", flexGrow: 1 }}>
          <div style={{ flexGrow: 1 }}>{action.name}</div>
          <GrDrag
            style={{ fontSize: 24, color: "var(--main)", cursor: "move" }}
          />
        </div>
        {action.condition && action.condition[0][0] && (
          <ConditionDisplay condition={action.condition} />
        )}
      </div>
      <div onClick={onDelete} className={styles.delete}>
        Delete
      </div>
      <div
        style={{
          color: "#333",
          fontSize: 24,
          marginTop: 8,
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: hovered ? 42 : 0,
        }}
      >
        <HiOutlineArrowNarrowDown />
      </div>
    </div>
  );
}

const ConditionDisplay = ({ condition = [""] }) => {
  const block = useMemo(() => ({ props: { condition } }), [condition]);
  const { _props } = usePropFormatter(block);

  if (!_props) {
    return null;
  }

  return (
    <div style={{ fontSize: 12, marginTop: 12, color: "#666" }}>
      Only Run When:
      <div
        style={{ textOverflow: "ellipsis", fontWeight: 600, color: "#333" }}
      >{`${_props.condition}`}</div>
    </div>
  );
};
